module.exports = __webpack_public_path__ + "img/BE_Mockups.ccc8949a.png";